import React from 'react';
import { Container, Card } from 'react-bootstrap';
import './Faq.css';

const FAQ = () => {
    const faqItems = [
        "Lorem ipsum dolor sit amet",
        "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium",
        "Et harum quidem rerum facilis est et expedita distinctio",
    ];

    return (
        <Container className="faq">
            <Card className="faq-card">
                <Card.Body>
                    <h2 className='faq-title'>FAQ</h2>
                    <ul className="faq-list">
                        {faqItems.map((item, index) => (
                            <li key={index}>
                                <a href="#" onClick={(e) => e.preventDefault()}>
                                    {item}
                                </a>
                            </li>
                        ))}
                    </ul>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default FAQ;
